/** Shared pager for client-side paginated tables. Hidden when everything fits on one page. */
import { Button, cn } from '@servicecompressionllc/sc-design-system';

interface PaginationProps {
  /** Zero-based current page. */
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export const Pagination = ({ page, pageCount, onPageChange, className }: PaginationProps) => {
  if (pageCount <= 1) return null;
  return (
    <nav
      className={cn('flex items-center justify-end gap-3 text-sm', className)}
      aria-label="Pagination"
    >
      <span className="text-ink-muted">
        Page {page + 1} of {pageCount}
      </span>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => onPageChange(page - 1)}
        disabled={page === 0}
      >
        Previous
      </Button>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= pageCount - 1}
      >
        Next
      </Button>
    </nav>
  );
};
